import React from 'react';
import { Bot } from 'lucide-react';
import { Card, CardContent } from '../Components/ui/card';

export default function AIAgents() {
  return (
    <div className="max-w-[1600px] mx-auto">
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
        <div className="flex items-center space-x-3">
          <div className="bg-gradient-to-br from-purple-500 to-purple-600 p-3 rounded-lg">
            <Bot className="h-6 w-6 text-white" />
          </div>
          <div>
            <h1 className="text-2xl font-bold text-gray-900">AI Agents</h1>
            <p className="text-sm text-gray-500">Manage AI-powered recruitment agents</p>
          </div>
        </div>
      </div>
      <Card className="mt-6 shadow-sm">
        <CardContent className="text-center py-12">
          <Bot className="h-12 w-12 text-gray-400 mx-auto mb-4" />
          <h3 className="text-lg font-medium text-gray-900 mb-2">AI Agents</h3>
          <p className="text-gray-500">Configure AI agents for automated recruitment tasks</p>
        </CardContent>
      </Card>
    </div>
  );
}